export * from './memo-component';
